import { render, staticRenderFns } from "./CongestionVessels.vue?vue&type=template&id=09f593a6&scoped=true&"
import script from "./CongestionVessels.vue?vue&type=script&lang=js&"
export * from "./CongestionVessels.vue?vue&type=script&lang=js&"
import style0 from "./CongestionVessels.vue?vue&type=style&index=0&id=09f593a6&scoped=true&lang=css&"
import style1 from "./CongestionVessels.vue?vue&type=style&index=1&id=09f593a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f593a6",
  null
  
)

export default component.exports